export default __webpack_public_path__ + "static/media/Heebo-SemiBold.97f6d5f4.ttf";